<template>
  <!-- Modal -->
  <div class="modal fade" ref="singleReplacementShippedWarehouseModal" id="SingleReplacementShippedWarehouseModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">返品データ選択</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>メーカー</th>
                  <th>JANコード</th>
                  <th>アイテムNo</th>
                  <th>型番</th>
                  <th>倉庫</th>
                  <th>在庫区分</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{detail.maker_name}}</td>
                  <td>{{detail.jan_code}}</td>
                  <td>{{detail.item_no}}</td>
                  <td>{{detail.model}}</td>
                  <td>{{detail.shipped_warehouse ? detail.shipped_warehouse.name : ''}}</td>
                  <td>{{detail.shipped_stock_type ? detail.shipped_stock_type.name : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th></th>
                <th>返品ID</th>
                <th>返品詳細ID</th>
                <th>取引先名</th>
                <th>納品先</th>
                <th>返品日</th>
                <th>到着日</th>
                <th>動作確認</th>
                <th>返品理由</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td><input type="radio" name="product" @change="changeSelectedRow(product)"></td>
                <td>{{ product.return_id}} </td>
                <td>{{ product.id}} </td>
                <td>{{ product.younosuke_company_name}} </td>
                <td>{{ product.destination_name }}</td>
                <td>{{ new Date(product.returned_at).toFormat('YYYY-MM-DD') }}</td>
                <td>{{ new Date(product.arrived_at).toFormat('YYYY-MM-DD') }}</td>
                <td>{{ $invoiceTools.getObjPropsById(return_states, Number(product.return_state_id), 'name') }}</td>
                <td>{{ $invoiceTools.getObjPropsById(return_reasons, Number(product.return_reason_id), 'name') }}</td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          <button type="button" class="btn btn-primary" @click="associateReturn">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SingleReplacementShippedWarehouseModal',
  components: {
    VueElementLoading
  },
  props: ['replacementDetail', 'index', 'returnDetail'],
  data () {
    return {
      detail: {},
      idx: null,
      warehouseProducts: [],
      isLoading: false,
      targetReturn: null
    }
  },
  created () {
  },
  mounted () {
    window.$(this.$refs.singleReplacementShippedWarehouseModal).on('shown.bs.modal', { self: this }, (e) => {
      e.data.self.detail = e.data.self.$props.replacementDetail
      e.data.self.idx = e.data.self.$props.index
      e.data.self.shippedWarehouseProducts()
    })
  },
  watch: {
  },
  computed: {
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_states () {
      return this.$store.getters['Return/getStates']
    }
  },
  methods: {
    shippedWarehouseProducts () {
      this.isLoading = true
      const params = {
        replacement_detail_id: this.detail.id,
        shipped_warehouse_id: this.detail.shipped_warehouse ? this.detail.shipped_warehouse.id : null,
        shipped_at: this.detail.shipped_at,
        shipped_stock_type_id: this.detail.shipped_stock_type ? this.detail.shipped_stock_type.id : null
      }
      const self = this
      this.$http.post(this.$api_url.replacement_shipped_warehouse_products, params).then(function (response) {
        if (response.data.status) {
          self.warehouseProducts = response.data.list
          console.log(3000)
          console.log(self.warehouseProducts)
        }
      }).finally(function () {
        self.isLoading = false
        self.targetReturn = null
        window.$('input[name="product"]').prop('checked', false)
      })
    },
    changeSelectedRow (product) {
      this.targetReturn = product
    },
    associateReturn () {
      if (!this.targetReturn) {
        this.$toastr.warning('返品データが選択されていません')
        return
      }
      this.$props.returnDetail.id = this.targetReturn.id
      this.$parent.onChangeShippedWarehouse(this.detail, this.idx)
      window.$(this.$refs.singleReplacementShippedWarehouseModal).modal('hide')
    }
  }
}
</script>
<style>
#SingleReplacementShippedWarehouseModal {
  z-index: 99999;
}
</style>
